import script from "./StudentScheduleTab.vue?vue&type=script&setup=true&lang=js"
export * from "./StudentScheduleTab.vue?vue&type=script&setup=true&lang=js"

import "./StudentScheduleTab.vue?vue&type=style&index=0&id=044d2e5c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-044d2e5c"]])

export default __exports__